// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 280;
export const HEADER_HEIGHT = 74;

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark'
};

// ==============================|| THEME CONFIG ||============================== //

const config = {
  fontFamily: `Inter var`,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  miniDrawer: false,
  container: false,
  themeContrast: false
};

export default config;